import script from "./layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./layout.vue?vue&type=script&lang=ts&setup=true"

import "./layout.vue?vue&type=style&index=0&id=4851eb28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4851eb28"]])

export default __exports__